import { message, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { fmtDate } from "../../extensions/utils";
import { isMobile, menuSize } from "@/extensions/design";

const StockDocMoves = ({ id }) => {
  const [moves, setMoves] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    serverFetch(`store/MovesByDocument?documentId=${id}&documentVid=2`)
      .then(data => {
        setMoves(data);
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }

  useEffect(getData, [id]);

  const columns = [
    { dataIndex: "moveId", title: "#", width: 60 },
    // { dataIndex: "moveDate", title: "Дата", render: fmtDate, width: 100 },
    // { dataIndex: "documentType", title: "Тип документа", width: 150 },
    // { dataIndex: "documentNumber", title: "№ док.", width: 80 },
    { dataIndex: "productName", title: "Наименование", align: "left", width: 200 },
    { dataIndex: "quantity", title: "Количество", align: "right", width: 100 },
    { dataIndex: "productExpUnit", title: "Ед.", width: 60 },
  ];

  return !isMobile ? (
    <div>
      <Table 
        dataSource={moves} 
        loading={loading} 
        columns={columns} 
        size="small" 
        className="table-item" 
        pagination={false} 
        rowKey="moveId"
      />
    </div>
  ) : (
  <div style={{ height: window.innerHeight - menuSize - 40}} className="stock-scrollable-list">
    {moves.map((move) => (
      <div className="client-item-sale" style={{backgroundColor:""}}>
        <div className="client-item-body">
          <div className="client-item-line-bold-double">
            <div className="client-item-clip">{move.productName}</div>
            <div className="client-item-clip-right" style={{fontWeight:"normal"}}>#{move.moveId}</div>
          </div>
          <div className="client-item-line-bold-double">
            <div className="client-item-clip" style={{fontWeight: "normal"}}> Кол-во: <strong>{move.quantity} {move.productExpUnit}</strong></div>
          </div>
        </div>
      </div>
    ))}
    {(moves.length === 0 && !loading) ?
      <div className="stock-no-data-text">Нет данных
      </div> : <></>}
  </div>);
}

export default StockDocMoves;